import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../api'
import CloseIcon from '../assets/icons/JSX/CloseIcon'
import UploadFileIcon from '../assets/icons/JSX/UploadFileIcon'
import Colors from '../assets/styles/Colors'
import Loader from './Loader'

const UploadFile: React.FC<{
  label?: string
  errorMessage?: string
  defaultFileName?: string
  onChange: (value: any) => void
  style?: React.CSSProperties
}> = ({ label = 'please enter label text', errorMessage, defaultFileName, onChange, style }) => {
  //
  //  upload file & image
  const [uploadFileMutation, { isLoading: isUploadFileLoading }] = api.useUploadFileMutation()
  //
  const [fileName, setFileName] = useState<string | undefined>(defaultFileName)
  //
  const fileOnchange = async (event: any) => {
    const fileObj = event.target.files && event.target.files[0]
    //
    if (!fileObj) {
      return
    }
    //
    //
    const file = event?.target?.files?.[0]
    //
    if (!file) {
      toast.error('გთხოვთ, აირჩიოთ ფაილი')
      return
    }
    //
    const result = await uploadFileMutation({ file }).unwrap()
    //
    onChange(result.url)
    //
    // reset file input
    event.target.value = null
  }
  //
  useEffect(() => {
    setFileName(defaultFileName)
  }, [defaultFileName])

  //
  return isUploadFileLoading ? (
    <Loader />
  ) : (
    <Wrapper style={style}>
      <Label>{label}</Label>
      <Box>
        <Input type="file" onChange={fileOnchange} />
        <UploadBox $selected={fileName ? true : false}>
          {fileName ? (
            <UploadedFile>
              <span>{fileName}</span>
              <CloseIcon onClick={() => setFileName(undefined)} />
            </UploadedFile>
          ) : (
            <>
              <UploadFileIcon />
              <span>ფაილის ატვირთვა</span>
            </>
          )}
        </UploadBox>
      </Box>
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
    </Wrapper>
  )
}
//
//
// styles
const ErrorMessage = styled.div`
  font-size: 14px;
  color: ${Colors.primaryRed};
  margin-top: 10px;
`
const UploadedFile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: 20px;

  svg {
    width: 13px !important;
    cursor: pointer;
    z-index: 3;
    position: absolute;
    right: 10px;
  }
  span {
    pointer-events: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`
const UploadBox = styled.div<{ $selected: boolean }>`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: ${Colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  pointer-events: ${({ $selected }) => ($selected === true ? 'all' : 'none')};
  border: 1px solid ${Colors.primaryBlack};

  /* span */
  span {
    font-size: 14px;
    line-height: 14px;
    color: ${Colors.primaryBlack};
    pointer-events: none;
  }

  /* icon svg */
  svg {
    margin-right: 10px;
    color: ${Colors.primaryBlack};
    height: 16px;
    width: fit-content;
    background-color: ${Colors.white};
  }
`
const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  background-color: ${Colors.white};
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  border-radius: 4px;
`
const Label = styled.label`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  margin-bottom: 12px;
`
const Input = styled.input`
  /* max-width: 265px; */
  height: 48px;
  width: 100%;
  background-color: ${Colors.white};
  border-radius: 4px;
  z-index: 1;
`
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default UploadFile
